import styled, { css } from "styled-components";
import { IAccordionProps } from "@template/components/Accordion/index.tsx";
import { AccordionItemWrapper } from "@template/components/Accordion/AccordionItem/styles.ts";

export const AccordionWrapper = styled.div<{
  $variant: IAccordionProps["variant"];
}>`
  ${({ $variant, theme }) => {
    switch ($variant) {
      case "underline":
      default:
        return css`
          ${AccordionItemWrapper} {
            &:not(:last-of-type) {
              border-bottom: 1px solid ${theme.colors.default[100]};
            }
          }
        `;
    }
  }}
`;

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
